//deps
import React, { memo, useCallback } from "react";

//constants
import { TEXTS, TIME_INTERVALS } from "@payment-client/components/autopay-payment-failure-screen/constants";

//internal-deps
import { TickScreen, TICK_ACCENT, TICK_STATES } from "@swiggy-private/payment-ui";

interface AutoPayTickScreenProps {
    goToTrackScreen: VoidFunction;
    isSubtleAutoplaceFlow?: boolean;
}

function AutoPayTickScreen({ goToTrackScreen, isSubtleAutoplaceFlow }: AutoPayTickScreenProps) {
    const postSuccessCb = useCallback(() => {
        setTimeout(() => {
            goToTrackScreen();
        }, TIME_INTERVALS.NAVIGATE_TO_TRACK_SCREEN);
    }, [goToTrackScreen]);

    return (
        <TickScreen
            tickState={TICK_STATES.SUCCESS}
            accent={isSubtleAutoplaceFlow ? TICK_ACCENT.MUSTARD : TICK_ACCENT.GREEN}
            mainText={TEXTS.TICK_SCREEN.MAIN_TEXT}
            subText={TEXTS.TICK_SCREEN.SUB_TEXT}
            postSuccessCb={postSuccessCb}
        />
    );
}

export default memo(AutoPayTickScreen);
